/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Header, Input, Tab } from 'semantic-ui-react'
import moment from 'moment'
import _ from 'lodash'
import firebase from '../../../config/firebase'
import utils from '../../../utils'

import PayingCustomer from './PayingCustomerReport'
import RestaurantActions from '../../../reducers/restaurantReducer'

class ReportConfiguration extends Component {
  constructor() {
    super()

    this.state = {
      orderFrom: Number(
        moment()
          .startOf('isoWeek')
          .format('x')
      ),
      orderTo: Number(
        moment()
          .endOf('isoWeek')
          .format('x')
      ),
      generating: false,
    }

    this.downloadLink = React.createRef()
  }

  componentDidMount() {
    const { restaurantLoaded, fetchRestaurants } = this.props

    if (!restaurantLoaded) {
      fetchRestaurants()
    }
  }

  onRangeChange = (field, value) => {
    let newValue

    if (field === 'orderFrom') {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    } else {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    }

    this.setState({ [field]: Number(newValue) })
  }

  onGenerateReport = () => {
    const { orderFrom, orderTo } = this.state

    if (orderTo < orderFrom) {
      alert('Invalid date input')
      return
    }

    this.handleGenerateReport()
  }

  getOrderByRange = () => {
    const { orderFrom, orderTo } = this.state

    firebase
      .database()
      .ref('orders')
      .orderByChild('created_at')
      .startAt(orderFrom)
      .endAt(orderTo)
      .once('value', snapshot => {
        const data = snapshot.val()

        this.handleOrderData(data)
      })
  }

  handleGenerateReport = () => {
    this.setState({ generating: true }, () => this.getOrderByRange())
  }

  handleOrderData = async orders => {
    const allUsers = {}

    await firebase
      .database()
      .ref('deliverees')
      .orderByChild('created_at')
      .once('value', snapshot => {
        snapshot.forEach(res => {
          allUsers[res.key] = {
            ...res.val(),
            uid: res.key,
          }
        })
      })

    const report = {}

    _.map(orders, (order, key) => {
      const { restaurants } = this.props
      const orderTo = order.restaurant.name
      const orderToKey = order.restaurant.key

      const eta = utils.order.getEta(order, restaurants[orderToKey])
      const items = utils.order.getOrderItems(order)
      const latency = utils.order.getLatency(order, eta)

      const orderDetail = {
        order_id: key,
        eta,
        latency,
        items,
        restaurant_name: orderTo,
        restaurant_id: orderToKey,
        order_date: moment(parseInt(order.created_at, 10)).format('DD-MMM-YYYY'),
        order_time: moment(parseInt(order.created_at, 10)).format('HH:mm'),
        delivered_time: moment(parseInt(order.updated_at, 10)).format('HH:mm'),
        distance: parseFloat(order.etaInfo.info.legs[0].distance.value / 1000).toFixed(2),
        sub_total: order.sub_total,
        delivery_fee: order.delivery_fee,
        discount: order.promotion_discount,
        order_status: order.status,
        reason_if_rejected:
          order.status === 'rejected' ? order.rejected_description || 'No description' : '',
      }

      if (report[order.deliveree]) {
        report[order.deliveree] = {
          ...report[order.deliveree],
          orders: [...report[order.deliveree].orders, orderDetail],
          order_delivery_locations: [
            ...report[order.deliveree].order_delivery_locations,
            order.delivery_address,
          ],
        }
      } else {
        report[order.deliveree] = {
          customer_name: order.deliveree_name,
          customer_phone: order.tel,
          registered_date:
            (allUsers[order.deliveree] &&
              allUsers[order.deliveree].created_at &&
              moment(allUsers[order.deliveree].created_at).format('DD-MMM-YYYY')) ||
            'Before 12-Sep-2018',
          orders: [orderDetail],
          order_delivery_locations: [order.delivery_address],
        }
      }
    })

    this.handleFinalReportJson(report, allUsers)
  }

  handleFinalReportJson(report, allUsers) {
    const modifiedReport = {}

    _.map(report, (eachReport, key) => {
      const userUid = key
      const userAddressesData = allUsers[userUid] && allUsers[userUid].address

      const allUserOrderSubTotal = Number(
        parseFloat(_.sumBy(eachReport.orders, order => order.sub_total)).toFixed(2)
      )
      const allUserOrderDeliveryFee = Number(
        parseFloat(_.sumBy(eachReport.orders, order => order.delivery_fee)).toFixed(2)
      )
      const allUserOrderDiscount = Number(
        parseFloat(_.sumBy(eachReport.orders, order => order.discount)).toFixed(2)
      )

      const deliveryAddresses = {}

      _.map(eachReport.order_delivery_locations, deliveryKey => {
        if (deliveryAddresses[deliveryKey]) {
          deliveryAddresses[deliveryKey] = {
            ...deliveryAddresses[deliveryKey],
            quantity: deliveryAddresses[deliveryKey].quantity + 1,
          }
        } else {
          deliveryAddresses[deliveryKey] = {
            coord: {
              latitude:
                (userAddressesData[deliveryKey] && userAddressesData[deliveryKey].latitude) || 0,
              longitude:
                (userAddressesData[deliveryKey] && userAddressesData[deliveryKey].longitude) || 0,
            },
            quantity: 1,
          }
        }
      })

      const orderLocationArr = _.map(deliveryAddresses, location => ({
        latitude: location.coord.latitude,
        longitude: location.coord.longitude,
        quantity: location.quantity,
      }))

      modifiedReport[key] = {
        ...eachReport,
        order_delivery_locations: orderLocationArr,
        total_order_amount: allUserOrderSubTotal,
        total_order_delivery_fee: allUserOrderDeliveryFee,
        total_order_discount: allUserOrderDiscount,
      }
    })

    const json = JSON.stringify(modifiedReport)

    this.handleUpload(json)
  }

  handleUpload(jsonText) {
    const storage = firebase
      .storage()
      .ref()
      .child(`report/report.json`)

    storage.putString(jsonText.toString()).then(snapshot => {
      this.handleDownload(snapshot)
    })
  }

  handleDownload(snapshot) {
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      this.setState({ generating: false, downloadUrl }, () => {
        this.downloadLink.click()
      })
    })
  }

  render() {
    const { downloadUrl, generating, orderFrom, orderTo } = this.state
    const { restaurantLoading } = this.props

    const orderFromValue = moment(orderFrom).format('YYYY-MM-DD')
    const orderToValue = moment(orderTo).format('YYYY-MM-DD')

    return (
      <Tab.Pane attached={false} loading={restaurantLoading} className="configuration-tab">
        <Header size="large">Generator Order report</Header>
        <div>
          <div>
            <div className="capitalize" style={{ display: 'inline-block', marginRight: 10 }}>
              From
            </div>
            <Input
              type="date"
              name="from"
              onChange={e => this.onRangeChange('orderFrom', e.target.value)}
              value={orderFromValue}
            />

            <div
              className="capitalize"
              style={{
                display: 'inline-block',
                marginLeft: 10,
                marginRight: 10,
              }}
            >
              To
            </div>
            <Input
              type="date"
              name="to"
              onChange={e => this.onRangeChange('orderTo', e.target.value)}
              value={orderToValue}
            />

            <Button
              loading={generating}
              disabled={generating}
              onClick={() => this.onGenerateReport()}
              style={{ marginLeft: 10 }}
            >
              Download Report
            </Button>
          </div>
          <a
            href={downloadUrl}
            ref={ref => {
              this.downloadLink = ref
            }}
            style={{ display: 'none' }}
          />
        </div>
        <div style={{ marginTop: 30 }}>
          <PayingCustomer />
        </div>
      </Tab.Pane>
    )
  }
}

const mapStateToProps = ({ restaurants }) => ({
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,
  restaurants: restaurants.data,
})

const mapDispatchToProps = dispatch => ({
  fetchRestaurants: () => dispatch(RestaurantActions.fetchRestaurantsRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportConfiguration)



// WEBPACK FOOTER //
// ./src/containers/configurations/Report/index.js